import oEmbed from 'kustaaPublic/scripts/components/oEmbed'

// We want SoundCloud players to have slightly different look.
oEmbed.oEmbedParams.beforeEmbed = (container) =>
{
  if(container.provider_name && container.provider_name === 'SoundCloud')
    container.code = container.code.replace(/\?visual=true/, '?visual=false')
}

export default oEmbed



// WEBPACK FOOTER //
// ./applications/publicFrontend/scripts/components/oEmbed.js